import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import styles from './Categories.module.css';
import NoData from './NoData';
import CategoryList from '../CategoryList/CategoryList';
import { requestUpdateCategories } from 'services/actions/adminActions';
import InactiveCategories from '../InactiveCategories/InactiveCategories';

const getInactiveCategories = (categories, activeCategories) => {
  const subcategories = _.flatMap(
    activeCategories,
    (category) => category.children
  );
  const flatList = [...activeCategories, ...subcategories];
  const activeIds = _.map(flatList, (category) => category.id);
  const inactiveList = _.filter(
    categories,
    (category) => !_.includes(activeIds, category.id)
  );
  const parentIds = _.uniq(
    _.map(inactiveList, (category) => category.parentCategoryId || category.id)
  );
  const inactiveCategories = _.map(parentIds, (id) => {
    return _.find(categories, (category) => category.id === id);
  });
  _.forEach(inactiveList, (category) => {
    if (category.parentCategoryId) {
      const index = _.findIndex(
        inactiveCategories,
        (item) => item.id === category.parentCategoryId
      );
      const { children = [] } = inactiveCategories[index];
      inactiveCategories[index] = {
        ...inactiveCategories[index],
        children: [...children, category],
      };
    }
  });
  return inactiveCategories;
};

export const Categories = ({
  campaign,
  categories,
  activeCategories,
  isLoading,
  isUpdating,
  updateCategories,
}) => {
  const noData = !campaign || isLoading;
  const noCategories = _.size(activeCategories) === 0;
  const inactiveCategories =
    !noCategories && getInactiveCategories(categories, activeCategories);

  if (noData) return <NoData campaign={!!campaign} isLoading={isLoading} />;

  if (campaign)
    return (
      <div className={styles.container}>
        <h2>{`${campaign.name}'s Categories`}</h2>
        <p className={styles.subtitle}>
          Organize the categories and subcategories of the navigation for this
          campaign.
        </p>
        {noCategories ? (
          <NoData campaign={!!campaign} isLoading={isLoading} />
        ) : (
          <div className={styles.categories}>
            <CategoryList
              categories={activeCategories}
              campaignId={campaign.id}
              isUpdating={isUpdating}
              updateCategories={updateCategories}
            />
            <InactiveCategories categories={inactiveCategories} />
          </div>
        )}
      </div>
    );

  return (
    <div>
      <p>Category List</p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  categories: state.adminState.categories,
  activeCategories: state.adminState.categoriesCampaign,
  isUpdating: state.adminState.updatingCategoriesCampaign,
});

const mapDispatchToProps = {
  updateCategories: requestUpdateCategories,
};

export default connect(mapStateToProps, mapDispatchToProps)(Categories);
